<script>
  import SocialShares from "$lib/components/SocialShares.svelte";

  export let data;
</script>

<SocialShares
  subtitle={data.fields.subtitle}
  title={data.fields.title}
  logo={data.fields.logo}
  shareText={data.fields.shareText}
/>
